import merge from "lodash/merge"

class ConfGuest {
  constructor() {
    this.id = 0
    this.name = ""
    this.introduction = ""
    this.image = null
    this.order = 0
    this.conference_id = 0
    this.create_time = new Date()
  }
  static getList(filters) {
    const url = process.env.VUE_APP_API_URL + "api/v1/confguestintro"
    if (!filters.per_page || filters.per_page == "") {
      filters.per_page = -1
    }
    return axios.get(url, { params: filters }).then((res) => {
      let returndata = {}
      returndata.result = []
      let c = new ConfGuest()
      res.data.results.forEach((x) => {
        let c = new ConfGuest()
        Object.assign(c, x)
        returndata.result.push(c)
      })
      returndata.total = res.data.total
      return returndata
    })
  }

  static async get_by_id(guest_id){
    const res = await ConfGuest.getList({id: guest_id})
    if(res.total>0){
      return res.result[0]
    }else{
      return null
    }
  }
}
export { ConfGuest }
